import {newStepValue, startStep} from "../../../../../services/flowBuilder/utils/constants";
import {EditPermissions} from "../../../../../../../shared/models";
import {Form, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {getEditTypes} from "../../../delegatorUtils";
import {required} from "../../../../../../../shared/utils";

export class ContactReceivingFormNode {
    menu: any = {};

    constructor(nodeType: string) {
        this.menu = {
            'menuType': nodeType,
        };
    }

    static toForm(stepData: { [index: string]: any }) {
        return {
            menuParams: this.menuParamsForm(stepData)
        };
    }

    static menuParamsForm(stepData) {
        const menu = stepData?.menu;
        let validateFields = this.validateFields(menu);
        return {
            text: menu?.text ? menu.text : '',
            varName: menu?.name ? menu.name : '',
            direction: 'inbound',
            validationMessage: menu?.menuParams.validationMessage ? menu.menuParams.validationMessage : '',
            validateFields,
            next: stepData?.next ? stepData.next : newStepValue
        }
    }

    static getMenuTemplate(editPermissions: EditPermissions): FormGroup {
        const {editFlows} = getEditTypes(editPermissions);
        return new FormGroup({
            varName: new FormControl({
                value: '',
                disabled: !editFlows
            }, [required('Node Name')]),
            text: new FormControl({
                value: '',
                disabled: !editFlows
            }, [required('Message To User')]),
            validationMessage: new FormControl({
                value: '',
                disabled: !editFlows
            }, [required('Validation Message')]),
            direction: new FormControl({
                value: 'inbound',
                disabled: !editFlows
            }),
            validateFields: new FormGroup({
                address: new FormControl({
                    value: false,
                    disabled: !editFlows
                }),
                name: new FormControl({
                    value: false,
                    disabled: !editFlows
                }),
                phone: new FormControl({
                    value: false,
                    disabled: !editFlows
                }),
                email: new FormControl({
                    value: false,
                    disabled: !editFlows
                }),
                birthday: new FormControl({
                    value: false,
                    disabled: !editFlows
                }),
                url: new FormControl({
                    value: false,
                    disabled: !editFlows
                }),
                org: new FormControl({
                    value: false,
                    disabled: !editFlows
                })
            }),
            next: new FormControl({
                value: '',
                disabled: !editFlows
            })
        })
    }

    addMenuParams(params): void {
        const {varName, text, validationMessage, direction, address} = params
        const menuParams = this.menu.menuParams ? this.menu.menuParams : {};
        const validateFields = this.sortValidationFields(params);
        this.menu = {
            ...this.menu,
            name:varName,
            text,
            menuParams: {
                ...menuParams,
                validationMessage,
                    direction,
                    address,
                validateFields
            }
        }
    }

    get nodeData(): {} {
        return {
            menu: this.menu,
            'type': 'menu',
            'next': newStepValue,
            metadata: {
                nodeVersion: '1.2.0'
            }
        };
    }

    private static validateFields(menu: any) {
        const fields: string[] = menu?.menuParams.validateFields ? menu?.menuParams.validateFields : [];
        return {
            address: fields.includes("address"),
            name: fields.includes("name"),
            phone: fields.includes("phone"),
            email: fields.includes("email"),
            birthday: fields.includes("birthday"),
            url: fields.includes("url"),
            org: fields.includes("org"),
        };
    }

    private sortValidationFields(menuParams: any) {
        const fields = menuParams?.validateFields;
        const fieldArray = [];
        for(let field in fields){
            if(fields[field])
              fieldArray.push(field);
        }
        return fieldArray;
    }
}